function CustomerSettings() {
  return <div>Customer Settings</div>;
}

export default CustomerSettings;
